import { ElementType, FC, ReactChild } from "react";
import { Box } from "@material-ui/core";
import clsx from "clsx";
import { useStyles } from "./style";
import { useSelector } from "react-redux";
import { RootState } from "../../../Redux/Reducers";
import ThemeExpiryAlertBar from "@/Components/ThemeExpiryAlertBar";

interface IPremiumHeader {
  customClassName?: string;
  customStyle?: any;
  children?: ReactChild;
  customComponent?: ElementType<any>;
  noAlertbar?: boolean;
  fullWidth?: boolean;
}

const PremiumHeader: FC<any> = (props: IPremiumHeader) => {
  const classes = useStyles();

  const { storeData } = useSelector((state: RootState) => ({
    storeData: state.storeReducer.store,
  }));

  return (
    <>
      {!props.noAlertbar && storeData?.theme?.is_demo === 1 && <ThemeExpiryAlertBar fixedBar />}
      <Box
        component={props.customComponent || "header"}
        className={clsx(
          classes.HeaderComponent,
          props.customClassName || "",
          "bg-white flex items-center fixed right-0",
          !props.fullWidth && "ph4",
        )}
        style={{ ...props.customStyle }}
      >
        <Box component="section" className="flex justify-between items-center w-100">
          {props.children}
        </Box>
      </Box>
    </>
  );
};

export default PremiumHeader;
